import * as uuid from 'uuid';
import { ITaskReminder } from 'services/TaskManagementApi/types/TaskManagementResponse';

export const UUIDV5_NAMESPACE = '27ba6479-1910-4f20-b2cd-424c58c49e5a';

export const generateStableReminderUuid = (reminder: ITaskReminder) => {
    return uuid.v5(`${reminder.channel}-${reminder.offset}-${reminder.offsetUnit}`, UUIDV5_NAMESPACE);
}